// extracted by mini-css-extract-plugin
export var alignRight = "component-module--alignRight--ced14";
export var containerNoPadding = "component-module--containerNoPadding--f24f0";
export var contentContainer = "component-module--contentContainer--ae22e";
export var fullWidth = "component-module--fullWidth--69de5";
export var grey = "component-module--grey--728c7";
export var h1 = "component-module--h1--44ea9";
export var h2 = "component-module--h2--417f9";
export var h3 = "component-module--h3--abe68";
export var h4 = "component-module--h4--c1ee5";
export var h5 = "component-module--h5--05b86";
export var light = "component-module--light--7b3c5";
export var lightColor = "component-module--lightColor--98d94";
export var offCenterLayout = "component-module--offCenterLayout--972d2";
export var reducedWidth = "component-module--reducedWidth--f5456";
export var section = "component-module--section--87984";
export var sectionNoSpacing = "component-module--sectionNoSpacing--dc100";
export var white = "component-module--white--2d4b2";